import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 0.4rem;
`

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (max-width: 768px) { padding-top: 16px; }
`
